
<template>
  <div class="bg-white">
    <div class="relative pb-10">
      <div>
        <div class="relative">
          <div class="absolute inset-0">
            <img class="w-full h-full object-cover" src="https://pslive.blob.core.windows.net/images/11-11/11-11-thumb.jpg" alt="" />
            <div class="absolute inset-0" aria-hidden="true" style="background-image: linear-gradient(to left bottom, rgba(0, 0, 0, 0.8), rgba(0, 0, 0, 0.8))" />
          </div>
          <div class="relative max-w-7xl mx-auto md:p-6">
            <div class="max-w-3xl mx-auto">
              <div>
                <img src="https://pslive.blob.core.windows.net/images/11-11/11-11-thumb.jpg" alt="" class="md:rounded-xl">
              </div>
            </div>
          </div>
        </div>
      </div>
      <div class="relative z-50 flex-none border-b py-2">
        <div class="mx-auto max-w-7xl px-4 sm:px-6 lg:px-8 flex flex-wrap items-center justify-center lg:flex-nowrap">
          <div class="flex space-x-2 md:space-x-4">
            <a class="inline-flex justify-center rounded-xl bg-black py-4 px-6 md:py-4 md:px-6 text-sm md:text-base font-semibold text-white hover:bg-gray-500 focus:outline-none focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-gray-500" href="https://forms.monday.com/forms/e5faf8148353beb2a5c58245e37c3da3?r=euc1&project_id=11_11_fast" target="_blank">
              Sign Up
            </a>
          </div>
        </div>
      </div>

      <div class="mx-auto max-w-7xl px-4 sm:px-6 lg:px-8" id="info-panel">
        <!-- <img class="mb-20 rounded-xl" src="/img/prayer-storm-conference-2025-1920x1080.jpg" /> -->

        <h1 class="mt-10 lg:mt-15 font-display text-4xl font-bold tracking-tighter text-gray-900 sm:text-6xl">
          11:11 Fast - Scripture Focus Guide
        </h1>
        <p class="mt-6 text-lg leading-8 text-gray-600">
          Please ensure you are signed up for the fast and use the scripture focus guide to help aid your prayer during the 11:11 fast.
        </p>
      </div>
    </div>

    <div class="mx-auto max-w-7xl px-4 pb-20 sm:px-6 lg:px-8">
        <div class="rounded-xl bg-gray-100 p-6 md:p-8">
          <p class="text-lg leading-8 text-gray-800">The 11:11 Fast is a 40-day fasting and prayer initiative centred on the Muslim world encountering Jesus during Ramadan. We are believing for salvation, spiritual breakthrough, and conversion from Islam to Christianity.</p>
          <p class="mt-4 text-lg leading-8 text-gray-800">The name comes from a prophetic dream in which the Church was shown to be at a spiritual deadlock, symbolised by a football match tied at 11–11, where victory required paying a price that had not yet been paid. The interpretation revealed a confrontation between the United Church and the advancing Islamic spirit, with the outcome hinging on the Church embracing the spirit of Elijah, associated with John the Baptist and a call to repentance and consecration.</p>
          <p class="mt-4 text-lg leading-8 text-gray-800">Anchored in Matthew 11:11–12, we are believing for Muslims to encounter Jesus through dreams, visions and the Spirit of Truth, for the breaking of spiritual blindness, for the restraint and defeat of the Jihadi spirit, and for the advance of the Kingdom of God through repentance, salvation, and transformed lives.</p>
          <p class="mt-4 text-lg leading-8 text-gray-800">This fast is a call for the Church to pay the price through prayer and fasting, trusting God to shift the scoreline from loss to victory for His Kingdom.</p>
          <p class="mt-4 text-lg leading-8 text-gray-800">We start our prayers with personal repentance and then will be focusing on three specific areas, against the Jihadi Spirit, for Muslims to encounter Jesus, and for the church to move in the power of God.</p>
        </div>

        <div class="mt-8 grid gap-4 md:grid-cols-2 lg:grid-cols-4">
          <a class="flex min-h-[64px] items-center justify-center rounded-xl border border-gray-300 bg-white px-4 py-4 text-center text-sm font-semibold text-gray-900 shadow-sm transition-all duration-200 hover:-translate-y-0.5 hover:border-gray-500 hover:bg-gray-50 hover:shadow focus:outline-none focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-gray-800" href="#repentance" @click.prevent="scrollToSection('repentance')">Repentance</a>
          <a class="flex min-h-[64px] items-center justify-center rounded-xl border border-gray-300 bg-white px-4 py-4 text-center text-sm font-semibold text-gray-900 shadow-sm transition-all duration-200 hover:-translate-y-0.5 hover:border-gray-500 hover:bg-gray-50 hover:shadow focus:outline-none focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-gray-800" href="#jihadi" @click.prevent="scrollToSection('jihadi')">Against the Jihadi Spirit</a>
          <a class="flex min-h-[64px] items-center justify-center rounded-xl border border-gray-300 bg-white px-4 py-4 text-center text-sm font-semibold text-gray-900 shadow-sm transition-all duration-200 hover:-translate-y-0.5 hover:border-gray-500 hover:bg-gray-50 hover:shadow focus:outline-none focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-gray-800" href="#encounter" @click.prevent="scrollToSection('encounter')">Muslims Encountering Jesus</a>
          <a class="flex min-h-[64px] items-center justify-center rounded-xl border border-gray-300 bg-white px-4 py-4 text-center text-sm font-semibold text-gray-900 shadow-sm transition-all duration-200 hover:-translate-y-0.5 hover:border-gray-500 hover:bg-gray-50 hover:shadow focus:outline-none focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-gray-800" href="#power" @click.prevent="scrollToSection('power')">For the Church to Move in the Power of God</a>
        </div>

        <section id="repentance" class="rounded-2xl bg-gray-900 p-6 text-white md:p-10 mt-8">
          <h2 class="font-display text-3xl font-bold tracking-tight">Repentance</h2>
          <div class="mt-6">
            <div class="rounded-xl bg-white/10">
              <ul class="space-y-2 text-gray-50 list-disc list-inside">
                <li class="leading-7">We humble ourselves before the Lord, turning from sin and self-reliance, and we receive His mercy and cleansing by the blood of Jesus. We choose godly repentance, not in outward form only, but with our hearts fully yielded to God.</li>
                <li class="leading-7">We declare that God is creating in us clean hearts and renewing right spirits within us. By faith, we will have the mind of Christ and take on His righteousness. We receive a new heart of flesh, and we welcome the Spirit of God to dwell and lead us.</li>
                <li class="leading-7">We declare that as we seek the Lord with sincerity, He hears from heaven and heals the land from the defilement of sin and wickedness.</li>
              </ul>
            </div>
            <div class="rounded-xl bg-white/10 mt-6">
              <ul class="scripture-list scripture-list-dark">
                <li class="scripture-row"><span class="scripture-text">As we corporately humble ourselves, pray, seek His face, and turn from our wicked ways, then God promises to heal our land</span><span class="scripture-ref">2 Chr 7:14</span></li>
                <li class="scripture-row"><span class="scripture-text">As we fast and pray, rend our hearts, weep and repent before the Lord, He will pour out His spirit on all generations and there will be deliverance</span><span class="scripture-ref">Joel 2:12 - 32</span></li>
                <li class="scripture-row"><span class="scripture-text">Create in me a clean heart, O God, and renew a right spirit within me</span><span class="scripture-ref">Psalm 51:10</span></li>
                <li class="scripture-row"><span class="scripture-text">If we confess our sins, He is faithful and just to forgive us our sins and to cleanse us from all unrighteousness</span><span class="scripture-ref">1 John 1:9</span></li>
                <li class="scripture-row"><span class="scripture-text">May God give us a new heart of flesh and put His Spirit within us</span><span class="scripture-ref">Eze 36:26-27</span></li>
              </ul>
            </div>
          </div>
        </section>

        <section id="jihadi" class="rounded-2xl bg-gray-900 p-6 text-white md:p-10 mt-8">
          <h2 class="font-display text-3xl font-bold tracking-tight">Against the Jihadi Spirit</h2>
          <div class="mt-6">
            <div class="rounded-xl bg-white/10">
              <ul class="space-y-2 text-gray-50 list-disc list-inside">
                <li class="leading-7">We declare that this battle is not against flesh and blood, but against spiritual powers, and Christ has already triumphed over them. Let God arise and His enemies be scattered according to His Word.</li>
                <li class="leading-7">We declare that every plan of darkness is frustrated and cannot succeed.</li>
                <li class="leading-7">We declare that the rod of wickedness is broken by the authority of the Lord.</li>
                <li class="leading-7">We declare that strongholds are demolished through the power of God,</li>
                <li class="leading-7">We lift up the name of Jesus and declare that every opposing spirit must bow to His Lordship, and the gates of hell will not prevail against the Church of Jesus Christ. The deception and power of the Jihadi spirit will lose its hold over our nation, government, schools, culture, and society.</li>
              </ul>
            </div>
            <div class="rounded-xl bg-white/10 mt-6">
              <ul class="scripture-list scripture-list-dark">
                <li class="scripture-row"><span class="scripture-text">Recognise our fight is not against flesh and blood but against spiritual forces of evil</span><span class="scripture-ref">Eph 6:12</span></li>
                <li class="scripture-row"><span class="scripture-text">Let God arise and His enemies be scattered</span><span class="scripture-ref">Psalm 68:1</span></li>
                <li class="scripture-row"><span class="scripture-text">The Lord frustrates the devices of the crafty, so that their hands achieve no success</span><span class="scripture-ref">Job 5:12</span></li>
                <li class="scripture-row"><span class="scripture-text">The Lord has broken the rod of the wicked, the sceptre of the rulers</span><span class="scripture-ref">Isa 14:5</span></li>
                <li class="scripture-row"><span class="scripture-text">Bring to an end the violence of the wicked and make the righteous secure</span><span class="scripture-ref">Psalm 7:9</span></li>
                <li class="scripture-row"><span class="scripture-text">The weapons of our warfare have divine power to demolish strongholds</span><span class="scripture-ref">2 Cor 10:3-5</span></li>
                <li class="scripture-row"><span class="scripture-text">The gates of hell will not prevail against the church</span><span class="scripture-ref">Matt 16:18</span></li>
                <li class="scripture-row"><span class="scripture-text">The Jihadi spirit will bow as we lift the name of Jesus</span><span class="scripture-ref">Phil 2:9-11</span></li>
              </ul>
            </div>
          </div>
        </section>

        <section id="encounter" class="rounded-2xl bg-gray-900 p-6 text-white md:p-10 mt-8">
          <h2 class="font-display text-3xl font-bold tracking-tight">Muslims Encountering Jesus</h2>
          <div class="mt-6">
            <div class="rounded-xl bg-white/10">
              <ul class="space-y-2 text-gray-50 list-disc list-inside">
                <li class="leading-7">We pray that Jesus Christ reveals Himself through dreams, visions, and the Spirit of Truth.</li>
                <li class="leading-7">We declare that veils are removed and hearts are opened to see the glory of Christ and that spiritual blindness is broken and eyes are opened to truth.</li>
                <li class="leading-7">We declare that many will encounter Jesus as Saul did on the road to Damascus, with lives radically transformed. We pray that people of influence and imams encounter Jesus and lead more Muslims to Jesus.</li>
                <li class="leading-7">We pray that the Father is drawing many to Himself, and none can resist His call.</li>
                <li class="leading-7">We declare salvation, repentance, and new life through Jesus Christ, the Way, the Truth, and the Life.</li>
              </ul>
            </div>
            <div class="rounded-xl bg-white/10 mt-6">
              <ul class="scripture-list scripture-list-dark">
                <li class="scripture-row"><span class="scripture-text">Pray that Muslims will have dreams or visions of ‘the Man in White' JESUS</span><span class="scripture-ref">Joel 2:28-29</span></li>
                <li class="scripture-row"><span class="scripture-text">For revelation of Jesus. Pray that the Lord will make His light shine in their hearts and experience His glory!</span><span class="scripture-ref">2 Cor 4:4-6</span></li>
                <li class="scripture-row"><span class="scripture-text">The Lord will remove the veil that has blinded them</span><span class="scripture-ref">2 Cor 3:16-18</span></li>
                <li class="scripture-row"><span class="scripture-text">Scales to fall off from their eyes</span><span class="scripture-ref">Acts 9:18</span></li>
                <li class="scripture-row"><span class="scripture-text">Their eyes will see you and their hearts will repent</span><span class="scripture-ref">Job 42:5-6</span></li>
                <li class="scripture-row"><span class="scripture-text">Saul of Tarsus like encounters. He had a dramatic encounter with Jesus on the road to Damascus</span><span class="scripture-ref">Acts 9:1-28; Acts 26:15-18</span></li>
                <li class="scripture-row"><span class="scripture-text">The Father will draw many Muslims to Himself</span><span class="scripture-ref">John 6:44; John 12:32</span></li>
                <li class="scripture-row"><span class="scripture-text">Salvation</span><span class="scripture-ref">2 Pet 3:9; 1 Tim 2:1-6</span></li>
                <li class="scripture-row"><span class="scripture-text">Revelation of Jesus as the Way, the Truth and the Life</span><span class="scripture-ref">John 14:6</span></li>
              </ul>
            </div>
          </div>
        </section>

        <section id="power" class="rounded-2xl bg-gray-900 p-6 text-white md:p-10 mt-8">
          <h2 class="font-display text-3xl font-bold tracking-tight">For the Church to Move in the Power of God</h2>
          <div class="mt-6">
            <div class="rounded-xl bg-white/10">
              <ul class="space-y-2 text-gray-50 list-disc list-inside">
                <li class="leading-7">We receive fresh baptism of the Holy Spirit and boldness to witness and speak the Word of God with confidence, trusting Him by faith to confirm it with signs and wonders.</li>
                <li class="leading-7">We declare that we walk in the authority given to us in Christ Jesus and that as we abide in Jesus, we will do the works He did, according to His promise.</li>
              </ul>
            </div>
            <div class="rounded-xl bg-white/10 mt-6">
              <ul class="scripture-list scripture-list-dark">
                <li class="scripture-row"><span class="scripture-text">The Kingdom of God is not a matter of talk but of power</span><span class="scripture-ref">1 Cor 4:20</span></li>
                <li class="scripture-row"><span class="scripture-text">Fresh baptism of the Holy Spirit and power</span><span class="scripture-ref">Acts 1:8</span></li>
                <li class="scripture-row"><span class="scripture-text">Revelation of the authority you have in Christ</span><span class="scripture-ref">Luke 10:19; Eph 1:18-21</span></li>
                <li class="scripture-row"><span class="scripture-text">Put your faith in Jesus and you will do the same things as Jesus and even greater</span><span class="scripture-ref">John 14:12; Acts 5:12; Acts 2:43</span></li>
                <li class="scripture-row"><span class="scripture-text">Speak boldly and confidently in the Lord</span><span class="scripture-ref">Acts 14: 3</span></li>
                <li class="scripture-row"><span class="scripture-text">Thank the Lord for His enabling to do perform signs and wonders</span><span class="scripture-ref">Acts 14:3</span></li>
              </ul>
            </div>
          </div>
        </section>
      </div>
  </div>
</template>

<script>
export default {
  methods: {
    scrollToSection (id) {
      const target = this.$el.querySelector(`#${id}`) || document.getElementById(id)
      if (target) {
        target.scrollIntoView({ behavior: 'smooth', block: 'start' })
      }
    }
  }
}
</script>

<style scoped>
.video-container {
    position: relative;
    padding-bottom: 56.25%; /* 16:9 */
    height: 0;
}
.video-container iframe {
    position: absolute;
    top: 0;
    left: 0;
    bottom: 0;
    width: 100%;
    height: 100%;
}

  .scripture-list {
    margin: 0;
    padding: 0;
    list-style: none;
    border-radius: 0.75rem;
    overflow: hidden;
  }

  .scripture-list-light {
    border: 1px solid #e5e7eb;
    background: #fff;
  }

  .scripture-list-dark {
    border: 1px solid rgba(255, 255, 255, 0.22);
    background: rgba(255, 255, 255, 0.06);
  }

  .scripture-row {
    display: grid;
    gap: 0.6rem;
    padding: 0.9rem 1rem;
    border-bottom: 1px solid #e5e7eb;
  }

  .scripture-list-dark .scripture-row {
    border-bottom-color: rgba(255, 255, 255, 0.2);
  }

  .scripture-row:last-child {
    border-bottom: none;
  }

  .scripture-text {
    font-size: 0.98rem;
    line-height: 1.65;
  }

  .scripture-ref {
    justify-self: start;
    font-family: ui-monospace, SFMono-Regular, Menlo, Monaco, Consolas, "Liberation Mono", "Courier New", monospace;
    font-size: 0.76rem;
    font-weight: 600;
    letter-spacing: 0.03em;
    border-radius: 9999px;
    padding: 0.32rem 0.62rem;
    white-space: nowrap;
  }

  .scripture-list-light .scripture-ref {
    background: #f3f4f6;
    color: #374151;
  }

  .scripture-list-dark .scripture-ref {
    background: rgba(255, 255, 255, 0.16);
    color: #f3f4f6;
  }

  @media (min-width: 768px) {
    .scripture-row {
      grid-template-columns: minmax(0, 1fr) auto;
      align-items: start;
      gap: 1rem;
      padding: 1rem 1.1rem;
    }

    .scripture-ref {
      justify-self: end;
    }
  }
</style>
